"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M11 21H3V3h8v18zm2 0h8v-9h-8v9zm8-11V3h-8v7h8z"
}), 'SpaceDashboardSharp');